<script setup>
import {onMounted, ref} from 'vue';
import ClientReportService from '@/services/ClientReportService';
import LineChart from '@/components/echarts/LineChart.vue';
import PieChart from '@/components/echarts/PieChart.vue';
import router from '@/router';
import {formatAmount, formatPercents, showSuccessMessage} from '@/helper';
import {useRoute} from 'vue-router';
import Welcome from '@/views/Welcome.vue';
import {createConfirmDialog} from 'vuejs-confirm-dialog';
import ClientService from '@/services/ClientService';
import UpdateClientComplexModal from '@/components/modals/UpdateClientComplexModal.vue';
import {authData, getLoggedUser} from '@/services/AuthService';
import {useI18n} from 'vue-i18n';

const {t} = useI18n()
const loading = ref(true);
const loggedClient = ref(null);
const loggedUser = ref(null);

onMounted(async () => {
  loading.value = false;

  getLoggedUser().then(response => {
    loggedClient.value = response.client;
    loggedUser.value = response;
  });
})


</script>
<template>
  <div v-if="!loggedUser?.meta?.show_form && loggedUser?.meta?.documents_to_sign > 0" class="row">
    <div class="col-12">
      <router-link to="/my-documents" class="alert alert-warning d-flex justify-content-between cursor-pointer text-decoration-none">
        <span>{{ t('dashboardIntermediary.unsigned_documents') }}</span>
        <u>{{ t('dashboardIntermediary.view_documents') }}</u>
      </router-link>
    </div>
  </div>
</template>

